import { useNavigate } from "react-router-dom";
import {
  getUserData,
} from "../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import ButtonLink from "../../ButtonLink";
import {
  getRackManualModel,
  postRackManualModel,
} from "../../services/RackModel/RackModel";

import StoreMenu from "../StoreMenu";

const RackManualModelStore = () => {
  const navigate = useNavigate();

  const { storeData,  } =
    getUserData();

 

  const storeId = storeData.id;

  const [rackModelList, setRackModelList] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [newRackName, setNewRackName] = useState("");
 
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
 

  const fetchRackModel = (storeId) => {
    setLoading(true);
    getRackManualModel(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setRackModelList(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  };

  // for all status and one week data or by default data;
 
  useEffect(() => {
   
    fetchRackModel(storeId);
 
  }, [storeId]);

  const rackItems = Array.isArray(rackModelList?.racks)
    ? rackModelList.racks
    : [];

  const filteredRackItems = rackItems.filter((rack) =>
    rack.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );

  const handleAddRack = () => {
    const value = newRackName.trim();
    if (!value) return;

    const existingRacks = Array.isArray(rackModelList?.racks)
      ? rackModelList.racks
      : [];

    const payload = {
      racks: [...existingRacks, value],
    };

    setLoading(true);
    postRackManualModel(storeId, payload)
      .then((response) => {
        const updatedRacks = response?.data?.racks || payload.racks;
        setRackModelList({ ...response.data, racks: updatedRacks });
        setNewRackName("");
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error adding rack:", err);
        setLoading(false);
      });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Rack Model
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      

      <div className="  my-2">
        <div className="m-4">
          <div className="flex gap-2 align-items-center">
            <input
              type="text"
              value={newRackName}
              onChange={(e) => setNewRackName(e.target.value)}
              placeholder="Add rack name"
              className="p-inputtext p-component flex-1"
              style={{ padding: "0.75rem 1rem", borderRadius: "8px" }}
            />
            <button
              type="button"
              onClick={handleAddRack}
              className="p-button p-component"
              style={{
                padding: "0.75rem 1rem",
                borderRadius: "8px",
                backgroundColor: "#1752AA",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Add
            </button>
          </div>

          <div className="mt-3">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search rack"
              className="p-inputtext p-component w-full"
              style={{ padding: "0.75rem 1rem", borderRadius: "8px" }}
            />
          </div>
        </div>

        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : filteredRackItems.length > 0 ? (
          <div className="m-4">
            {filteredRackItems.map((item, index) => (
              <div key={`${item}-${index}`} className="flex-1 mb-3">
                <div className="m-4 shadow-4">
                  <div className="flex flex-1">
                    <div
                      className="flex-1 px-3 py-1"
                      style={{ backgroundColor: "#F8FFEE" }}
                    >
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        #
                      </p>
                      <p className="text-lg font-medium capitalize">
                        {index + 1}
                      </p>
                    </div>
                    <div
                      className="flex-1 px-3 py-1"
                      style={{ backgroundColor: "#E2F4F8" }}
                    >
                      <p
                        className="text-md font-normal capitalize"
                        style={{ color: "#75879B" }}
                      >
                        Rack Name
                      </p>
                      <p className="text-lg font-medium capitalize">
                        {item}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">No Rack Found</p>
          </div>
        )}

        <StoreMenu setVisible={setVisible} visible={visible} />
        <ButtonLink />
      </div>
    </div>
  );
};

export default RackManualModelStore;
